import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { useScrollable } from './useScrollable';
export const ScrollableHeader = t0 => {
  const $ = _c(6);
  const {
    children,
    hideBorderWhenOnTop
  } = t0;
  const {
    isScrolledVertically
  } = useScrollable();
  const t1 = hideBorderWhenOnTop ? "none" : "1px solid var(--mui-palette-divider)";
  const t2 = isScrolledVertically ? "var(--mui-customShadows-panel)" : undefined;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      borderBottom: t1,
      boxShadow: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t3) {
    t4 = <Stack sx={t3}>{children}</Stack>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};